import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_KNOWLEDGE_PORTAL_PATH,
  GetKnowledgePortalErrorDto,
  GetKnowledgePortalSuccessDto,
} from '@/api/rest/resources/types/knowledge';

type SuccessDto = GetKnowledgePortalSuccessDto;
type ErrorDto = GetKnowledgePortalErrorDto;

export const useKnowledgePortal = () => {
  const queryFn = async () => {
    return getRequest<SuccessDto>(GET_KNOWLEDGE_PORTAL_PATH, undefined, undefined);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['knowledge-portal'],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
